import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog as MuiDialog,
  SxProps,
  Theme,
} from "@mui/material";
import { FC, PropsWithChildren, ReactNode } from "react";

interface IDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
  fullScreen?: boolean;
  noTitleDivider?: boolean;
  titleSize?: string | number;
}

const Dialog: FC<PropsWithChildren<IDialogProps>> = ({
  open,
  onClose,
  title = "",
  children = null,
  actions,
  sx,
  fullScreen = false,
  noTitleDivider = false,
  titleSize = "",
}) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      fullWidth
      // maxWidth="sm"
      sx={{
        "& .MuiPaper-root": fullScreen
          ? {
              borderRadius: "0",
              padding: "0",
            }
          : {
              borderRadius: "16px",
              padding: "32px",
            },
        ...sx,
      }}
      fullScreen={fullScreen}
    >
      {" "}
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          color: "grey.600",
        }}
      >
        <CloseIcon height={24} width={24} />
      </IconButton>
      {title && (
        <DialogTitle
          sx={
            fullScreen
              ? {
                  boxShadow: "0 4px 18px 8px #0000001F",
                  py: 2.5,
                  pl: 2,
                  pr: 5.5,
                  ...(titleSize && { fontSize: titleSize }),
                }
              : {
                  borderBottom: !noTitleDivider ? "1px solid #E0E0E0" : "none",
                  mb: !noTitleDivider ? 3 : 0,
                  pl: 0,
                  ...(titleSize && { fontSize: titleSize }),
                }
          }
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent
        sx={fullScreen ? { padding: "24px 16px !important" } : { py: 3, px: 0 }}
      >
        {children}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
